import React, { useEffect, useRef } from 'react';
import { useSeasonTheme } from 'context/SeasonThemeContext';
import 'assets/css/SnowEffect.css';

const SnowEffect = () => {
    const { seasonTheme } = useSeasonTheme();
    const containerRef = useRef();

    useEffect(() => {
        if (seasonTheme !== 'christmas') return;

        const snowContainer = containerRef.current;
        if (!snowContainer) return;

        const createSnowflake = () => {
            const snowflake = document.createElement('div');
            snowflake.className = 'snowflake';
            snowflake.style.left = `${Math.random() * 100}%`;
            snowflake.style.animationDuration = `${Math.random() * 3 + 5}s`;
            snowflake.style.animationDelay = `${Math.random() * 3}s`;
            snowflake.style.opacity = Math.random();

            const size = Math.random() * 10 + 5;
            snowflake.style.width = `${size}px`;
            snowflake.style.height = `${size}px`;

            snowContainer.appendChild(snowflake);

            setTimeout(() => {
                if (snowflake.parentNode) {
                    snowflake.remove();
                }
            }, 10000);
        };

        const interval = setInterval(createSnowflake, 100);

        return () => clearInterval(interval);
    }, [seasonTheme]);

    if (seasonTheme !== 'christmas') return null;

    return (
        <div ref={containerRef} className="snow" />
    );
};

export default SnowEffect;
